import { FC, Fragment } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import Column from '../../../Pdf/components/Column';
import Divider from '../../../Pdf/components/Divider';
import Row from '../../../Pdf/components/Row';
import Typography from '../../../Pdf/components/Typography';
import theme from '../../../Pdf/components/theme';

const styles = StyleSheet.create({
  summary: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
    borderRadius: 6,
    padding: '8px',
    backgroundColor: theme.palette.background.default,
    gap: '8px',
  },
  summaryItem: {
    flex: 1,
    gap: theme.spacing(theme.spacingSizes.xxs),
  },
  summaryLabel: {
    fontSize: '5.5px',
    lineHeight: '100%',
    fontWeight: 500,
    color: theme.palette.grey[600],
  },
  summaryValue: {
    fontSize: '6px',
    lineHeight: '150%',
    fontWeight: 500,
    color: theme.palette.grey[900],
  },
  summaryValueWithSuffix: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: '4px',
  },
  summaryValueSuffix: {
    fontSize: '5.5px',
    lineHeight: '150%',
    fontWeight: 400,
    color: theme.palette.grey[500],
  },
});

export type FundCashFlowAndIrrSummaryItem = {
  label: string;
  value: string;
  suffix?: string;
};

type Props = {
  summaryItems: Array<FundCashFlowAndIrrSummaryItem>;
};

const FundCashFlowAndIrrSummary: FC<Props> = ({ summaryItems }) => {
  return (
    <Row fullWidth style={styles.summary}>
      {summaryItems.map((item, index) => (
        <Fragment key={item.label}>
          <Column style={styles.summaryItem}>
            <Typography style={styles.summaryLabel}>{item.label}</Typography>
            {item.suffix ? (
              <Row style={styles.summaryValueWithSuffix}>
                <Typography style={styles.summaryValue}>
                  {item.value}
                </Typography>
                <Typography style={styles.summaryValueSuffix}>
                  {item.suffix}
                </Typography>
              </Row>
            ) : (
              <Typography style={styles.summaryValue}>{item.value}</Typography>
            )}
          </Column>
          {index < summaryItems.length - 1 ? (
            <Divider orientation="vertical" width={1} />
          ) : null}
        </Fragment>
      ))}
    </Row>
  );
};

export default FundCashFlowAndIrrSummary;
